"use client";
/* eslint-disable @typescript-eslint/no-unused-vars */
import MuawinChat from "@/components/MuawinChat";
import { usePathname } from "next/navigation";

export default function LeadgenLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const pathname = usePathname();
  console.log("Pathname ", !pathname.endsWith("login") || !pathname.endsWith("privacy"))
  return (
    <>
      {children}
      {(!pathname.endsWith("privacy") && !pathname.endsWith("login")) && (
        <div>
          <MuawinChat />
        </div>
      )}
    </>
  );
}
